import { Link } from "react-router-dom";
import { imgUrl, fmtDate } from "@/lib/api";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import StatusBadge from "@/components/StatusBadge";
import { BadgeCheck, Star, AlertTriangle } from "lucide-react";

export default function GuestCard({ g }) {
  return (
    <div className="rounded-2xl bg-stone-50 p-4" data-testid={`guest-card-${g.user_id}`}>
      <div className="flex items-center gap-3">
        <Avatar className="h-12 w-12"><AvatarImage src={imgUrl(g.picture)} /><AvatarFallback>{g.name?.[0]}</AvatarFallback></Avatar>
        <div className="min-w-0">
          <Link to={`/users/${g.user_id}`} className="font-semibold hover:underline" data-testid="guest-card-name">{g.name}</Link>
          <p className="flex items-center gap-1 truncate text-xs text-stone-600" data-testid="guest-card-email">
            <BadgeCheck className="h-3.5 w-3.5 text-primary" />{g.email} · verified
          </p>
        </div>
      </div>
      <div className="mt-3 grid grid-cols-3 gap-2 text-center text-xs">
        <div className="rounded-xl bg-white p-2"><p className="font-mono-num text-base font-semibold" data-testid="guest-card-stays">{g.past_stays}</p>past stays</div>
        <div className="rounded-xl bg-white p-2"><p className="font-mono-num text-base font-semibold">{g.guest_rating ?? "–"}</p>host rating</div>
        <div className="rounded-xl bg-white p-2"><p className={`font-mono-num text-base font-semibold ${g.complaints?.length ? "text-secondary" : ""}`} data-testid="guest-card-complaints">{g.complaints?.length || 0}</p>complaints</div>
      </div>
      {g.guest_reviews?.slice(0, 2).map((r) => (
        <div key={r.review_id} className="mt-3 rounded-xl bg-white p-3 text-xs">
          <p className="mb-1 flex items-center gap-1 font-semibold"><Star className="h-3 w-3 fill-amber-400 text-amber-400" />{r.rating} · {r.author?.name}</p>
          <p className="text-stone-600">{r.comment}</p>
        </div>
      ))}
      {g.complaints?.length > 0 && (
        <div className="mt-3 space-y-1 text-xs" data-testid="guest-card-complaint-history">
          {g.complaints.map((c) => (
            <p key={c.complaint_id} className="flex items-center gap-2"><AlertTriangle className="h-3 w-3 text-secondary" />{c.category} · {fmtDate(c.created_at)} <StatusBadge status={c.decision || c.status} /></p>
          ))}
        </div>
      )}
    </div>
  );
}
